export const ActiveProduct = {
    SET: 'SET_ACTIVE_PRODUCT',
    ISPRIME: 'ISPRIME',
};
